import styled from "@emotion/styled";

export const EmptyHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 20px;
  padding-bottom: 20px;
  font-family: var(--font-family-sans);
  font-weight: var(--font-weight-semibold);
  text-align: center;
  width: 100%;
`;
